import { type Booklet, type ReviewState, WithoutIdAndReview, PhilatelicItemType } from "@briefmarken_katalog/types";
import type { TranslationKey } from "$lib/i18n";
import { CollectionEditorModelBase } from "./CollectionEditorModelBase.svelte";

export class BookletEditorModel extends CollectionEditorModelBase<Booklet> {
  size_width = $state(0);
  size_height = $state(0);

  constructor({
    onCreate = (_booklet: WithoutIdAndReview<Booklet>) => {},
    onReview = (_booklet: WithoutIdAndReview<Booklet>, _state: ReviewState) => {},
    onDelete = () => {},
    isReadonly = false,
    isReview = false,
    isDelete = false,
    isEdit = false,
    initialValue = null,
    dialogTitle = 'editor.bookletEditorTitle' as TranslationKey,
    dialogSubtitle = 'editor.bookletEditorSubtitle' as TranslationKey,
  }: {
    onCreate?: (booklet: WithoutIdAndReview<Booklet>) => void;
    onReview?: (booklet: WithoutIdAndReview<Booklet>, state: ReviewState) => void;
    onDelete?: () => void;
    isReadonly?: boolean;
    isReview?: boolean;
    isDelete?: boolean;
    isEdit?: boolean;
    initialValue?: Booklet | null;
    dialogTitle?: TranslationKey;
    dialogSubtitle?: TranslationKey;
  } = {}) {
    super({ onCreate, onReview, onDelete, isReadonly, isReview, isDelete, isEdit,
            initialValue, dialogTitle, dialogSubtitle });
    if (initialValue) {
      this.size_width = initialValue.size?.width ?? 0;
      this.size_height = initialValue.size?.height ?? 0;
    }
  }

  buildItem(): WithoutIdAndReview<Booklet> {
    return {
      title: this.title,
      description: this.description,
      date_of_issue: this.date_of_issue!,
      expiry_date: this.expiry_date ?? undefined,
      size: { width: this.size_width, height: this.size_height },
      print_run: this.print_run ?? undefined,
      categories: this.categories.length > 0 ? this.categories : undefined,
      catalog_ids: Object.keys(this.catalog_ids).length > 0 ? this.catalog_ids : undefined,
      zhihao: this.zhihao,
      pictures: this.pictures,
      stamps: this.stampIds,
      type: PhilatelicItemType.Booklet,
    };
  }
}
